import axios from '@/libs/api.request'

export const getBannerList = (params) => {
  return axios.request({
    method: 'get',
    params,
    url: '/banner'
  })
}

export const getWebBannerList = (params) => {
  return axios.request({
    method: 'get',
    params,
    url: '/banner/web'
  })
}

export const addBanner = (data) => {
  return axios.request({
    method: 'post',
    data,
    url: '/banner/appBanner'
  })
}

export const addBannerWeb = (data) => {
  return axios.request({
    method: 'post',
    data,
    url: '/banner/webBanner'
  })
}

export const editBanner = (data) => {
  return axios.request({
    method: 'put',
    data,
    url: '/banner'
  })
}

export const changeBannerStatus = (id) => {
  return axios.request({
    method: 'put',
    url: '/banner/status/' + id
  })
}

export const delBanner = (id) => {
  return axios.request({
    method: 'delete',
    url: '/banner/' + id
  })
}

export const getBannerInfo = (id) => {
  return axios.request({
    method: 'get',
    url: '/banner/' + id
  })
}
